import { Platforms } from './types';

export const DESCRIPTION_CHAR_LIMIT = 3000;
export const HALF_SELECT_LIST_HEIGHT = 140;
export const FRIENDLY_SITES = ['Tap.az', 'Bina.az', 'Boss.az'];

export const POND_URL = `${process.env.POND_SERVER_URL}/pond`;
export const API = {
  MAKES: '/api/v2/properties/makes.json',
  PROPERTIES: '/api/v2/properties/options.json',
  PROFILE: '/api/v2/profile.json',
  LOGIN: '/session/login.json',
  LOGOUT: '/session/logout',
  CATALOG: '/api/v2/catalog/form_data.json',
  NEW_AD: '/api/v2/autos.json'
};
export const SITE_LINKS = {
  HELP: '/help/popular_questions',
  TERM_AND_CONDITIONS: '/pages/terms-and-conditions',
  PRIVACY: '/pages/privacy',
  RULES: '/pages/rules',
  ORDER: '/pages/order-recommendations',
  LAW: '/pages/law',
  PROPOSAL: '/pages/proposal'
};
export const BREAKPOINTS = {
  mobile: '600px',
  tablet: '768px',
  desktop: '1279px'
};
export const EXTERNAL_LINKS_CONFIG = {
  quick: {
    links: {
      accessories: 4045,
      'audio-video': 4046,
      chemical: 4044,
      spares: 4047,
      gps: 4043,
      numbers: 4119,
      anti_theft_dev: 4048,
      videoreg: 7476,
      tires: 4050,
      others: 4051
    },
    buildPath: (key: string) =>
      key === 'numbers'
        ? 'elanlar/neqliyyat/qeydiyyat-nisanlari'
        : 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
    buildQuery: (key: string, value: number) =>
      `?p%5B798%5D=${value}&utm_source=turboaz&utm_medium=link&utm_content=accessories&utm_campaign=desktop`,
    dataStatPrefix: ''
  },
  rental: {
    links: {
      cars: 40752,
      buses: 40753,
      bikes: 40755,
      commerce_transport: 40754,
      other: 40756
    },
    buildPath: () => 'elanlar/xidmetler/neqliyyat-icaresi',
    buildQuery: (key: string, value: number) =>
      `?p%5B1008%5D=${value}&utm_source=turboaz&utm_medium=desktop&utm_campaign=rentacar&utm_id=header_${key}`,
    dataStatPrefix: 'rental-'
  }
};
export const HEADER_MENU_LINKS = {
  first: [
    {
      key: 'faq',
      url: SITE_LINKS.HELP
    },
    {
      key: 'agreement',
      url: SITE_LINKS.TERM_AND_CONDITIONS
    },
    {
      key: 'privacy',
      url: SITE_LINKS.PRIVACY
    },
    {
      key: 'rules',
      url: SITE_LINKS.RULES
    }
  ],
  second: [
    {
      key: 'order_recommendations',
      url: SITE_LINKS.ORDER
    },
    {
      key: 'advertisement',
      url: (subdomain: string) =>
        `https://${subdomain}ads.digit.az/?utm_source=turboaz&utm_medium=referral&utm_campaign=turboaz_referral&utm_content=header`
    },
    {
      key: 'law',
      url: SITE_LINKS.LAW
    }
  ]
};
export const StepsMap = {
  make_id: {
    step: 1,
    nextStep: () => 2
  },
  model_id: {
    step: 2,
    nextStep: () => 3
  },
  reg_year: {
    step: 3,
    nextStep: () => 4
  },
  category_id: {
    step: 4,
    nextStep: (isCatalog: boolean) => (isCatalog ? 5 : 6)
  },
  generation: {
    step: 5,
    nextStep: () => 6
  },
  fuel_type_id: {
    step: 6,
    nextStep: () => 7
  },
  gear_id: {
    step: 7,
    nextStep: () => 8
  },
  transmission_id: {
    step: 8,
    nextStep: () => 9
  },
  modification: {
    step: 9,
    nextStep: () => 10
  },
  engine_volume: {
    step: 9,
    nextStep: () => 10
  },
  seats_count: {
    step: 10,
    nextStep: () => 10
  },
  color_id: {
    step: 10,
    nextStep: () => 10
  },
  others: {
    step: 10,
    nextStep: () => 10
  }
};

export const rusKeyToLat: Record<string, string> = {
  й: 'q',
  ц: 'w',
  у: 'e',
  к: 'r',
  е: 't',
  н: 'y',
  г: 'u',
  ш: 'i',
  щ: 'o',
  з: 'p',
  х: '[',
  ъ: ']',
  ф: 'a',
  ы: 's',
  в: 'd',
  а: 'f',
  п: 'g',
  р: 'h',
  о: 'j',
  л: 'k',
  д: 'l',
  ж: ';',
  э: "'",
  я: 'z',
  ч: 'x',
  с: 'c',
  м: 'v',
  и: 'b',
  т: 'n',
  ь: 'm',
  б: ',',
  ю: '.',
  Й: 'Q',
  Ц: 'W',
  У: 'E',
  К: 'R',
  Е: 'T',
  Н: 'Y',
  Г: 'U',
  Ш: 'I',
  Щ: 'O',
  З: 'P',
  Х: '{',
  Ъ: '}',
  Ф: 'A',
  Ы: 'S',
  В: 'D',
  А: 'F',
  П: 'G',
  Р: 'H',
  О: 'J',
  Л: 'K',
  Д: 'L',
  Ж: ':',
  Э: '"',
  Я: 'Z',
  Ч: 'X',
  С: 'C',
  М: 'V',
  И: 'B',
  Т: 'N',
  Ь: 'M',
  Б: '<',
  Ю: '>'
};

export const PlatformsList: Platforms = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
};

export const TOP_LIST_COUNT = 20;
